// extracted by mini-css-extract-plugin
export default {"loading-page__row":"_1t1tSdUuEJwlnG0hZgi48_","loading-page__title":"_2j9qx_KUfWhFcQJRO9hBav"};